import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import '@mdi/font/css/materialdesignicons.css'
import axios from 'axios'
import Toast from 'vue-toastification'
import "vue-toastification/dist/index.css"
import { dataTableDefaults } from './mixins/dataTableDefaults'

Vue.mixin(dataTableDefaults);
Vue.use(Toast, {
  transition: "Vue-Toastification__bounce",
  maxToasts: 20,
  newestOnTop: true
});

Vue.config.productionTip = false
Vue.prototype.$axios = axios

async function initApp() {
  try {
    const res = await fetch('/config.json');
    const config = await res.json();

    axios.defaults.baseURL = config.API_BASE_URL;
    //console.log('API_BASE_URL configurada:', config.API_BASE_URL);
  } catch (error) {
    console.error('Error cargando config.json:', error);
    return;
  }
  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App),
    async created() {
      let tokenSession = store.state.token;
      if (tokenSession) {
        //this.$router.push({ 'path': '/main' }).catch(() => { });
      } else {
        this.$router.push({ 'path': '/' }).catch(() => { });
      }
    }
  }).$mount('#app')
}
initApp();

